module.exports = __webpack_public_path__ + "img/trash-icon.d4a76b71.svg";